import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { IconButtonComponent, TooltipDirective } from '@mode/capra';

@Component({
  selector: 'mode-color-dropper',
  standalone: true,
  imports: [CommonModule, IconButtonComponent, TooltipDirective],
  templateUrl: './color-dropper.component.html',
  styleUrls: ['./color-dropper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorDropperComponent {
  @Output() colorSelected = new EventEmitter<string>();

  isSupported = false;

  constructor(private _window: Window) {
    this.isSupported = typeof (this._window as any).EyeDropper === 'function';
  }

  openDropper() {
    if (!this.isSupported) {
      return;
    }

    try {
      const eyeDropper = new (this._window as any).EyeDropper();
      eyeDropper
        .open()
        .then((result: { sRGBHex: string }) => {
          this.colorSelected.emit(result.sRGBHex);
        })
        .catch((e: Error) => {
          console.error(e);
        });
    } catch (e) {
      console.error(e);
    }
  }
}
